module.exports = __webpack_public_path__ + "5cf92f18235678ea797cc8cc023b980b.pdf";